import { render, staticRenderFns } from "./table-input.vue?vue&type=template&id=54488ca6&scoped=true"
import script from "./table-input.vue?vue&type=script&lang=js"
export * from "./table-input.vue?vue&type=script&lang=js"
import style0 from "./table-input.vue?vue&type=style&index=0&id=54488ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54488ca6",
  null
  
)

export default component.exports